import { UserPreferencesQueries } from "@/application/queries/user.queries";
import { UserPreferencesAppServices } from "@/application/services/user/user.service";
import { useMutation, useQueryClient } from "@tanstack/react-query";

function useUpdateUserPreferencesByID() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: UserPreferencesAppServices.updateByID,
    mutationKey: [UserPreferencesQueries._def, "update", "by-id"],
    onSuccess: () => {
      // TODO: INVALIDATE NOT WORKING WITH QUERY FUNCTION
      queryClient.invalidateQueries({
        queryKey: ["user-preferences","getByUserID","user"],
      });
      // queryClient.invalidateQueries({
      //   queryKey: [UserPreferencesQueries.getByUserID(ID).queryKey],
      // });
    },
  });
}

function useCreateUserPreferences() {
  return useMutation({
    mutationFn: UserPreferencesAppServices.create,
    mutationKey: [UserPreferencesQueries._def, "create"],
  });
}

function useDeleteUserPreferencesByID() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: UserPreferencesAppServices.deleteByID,
    mutationKey: [UserPreferencesQueries._def, "delete", "by-id"],
    onSuccess: (_, ID) => {
      queryClient.invalidateQueries({
        queryKey: [UserPreferencesQueries.getByUserID(ID).queryKey],
      });
    },
  });
}

export {
  useUpdateUserPreferencesByID,
  useCreateUserPreferences,
  useDeleteUserPreferencesByID,
};
